import type { HoverActionKey } from "owa-outlook-service-option-store";
import { default as Delete } from "owa-fluent-icons-svg/lib/icons/DeleteRegular";
import { default as Flag } from "owa-fluent-icons-svg/lib/icons/FlagRegular";
import { default as Archive } from "owa-fluent-icons-svg/lib/icons/ArchiveRegular";
import { default as FolderArrowRight } from "owa-fluent-icons-svg/lib/icons/FolderArrowRightRegular";
import { default as MailRead } from "owa-fluent-icons-svg/lib/icons/MailReadRegular";
import { default as Pin } from "owa-fluent-icons-svg/lib/icons/PinRegular";

import { bundleIcon, DeleteRegular, DeleteFilled, MailRegular, MailFilled, MailReadRegular, MailReadFilled, FlagRegular, FlagFilled, ArchiveRegular, ArchiveFilled, FolderArrowRightRegular, FolderArrowRightFilled, PinRegular, PinFilled, SettingsRegular, SettingsFilled, CheckmarkRegular, CheckmarkFilled, MailCheckmarkRegular, MailCheckmarkFilled, } from "@fluentui/react-icons";
import type { SurfaceActionIcon } from "../types/SurfaceActionIcon";
import type { SurfaceActionIconWithFluentIcon } from "../types/SurfaceActionIconWithFluentIcon";

const DeleteIcon = bundleIcon(DeleteFilled, DeleteRegular);
const MailIcon = bundleIcon(MailFilled, MailRegular);
const MailReadIcon = bundleIcon(MailReadFilled, MailReadRegular);
const FlagIcon = bundleIcon(FlagFilled, FlagRegular);
const PinIcon = bundleIcon(PinFilled, PinRegular);
const CheckmarkIcon = bundleIcon(CheckmarkFilled, CheckmarkRegular);
const ArchiveIcon = bundleIcon(ArchiveFilled, ArchiveRegular);
const FolderArrowRightIcon = bundleIcon(FolderArrowRightFilled, FolderArrowRightRegular);
const SettingsIcon = bundleIcon(SettingsFilled, SettingsRegular);
const MailCheckmarkIcon = bundleIcon(MailCheckmarkFilled, MailCheckmarkRegular);

export function getHoverActionIconName(key: HoverActionKey): SurfaceActionIcon {
    let iconName: string;
    switch (key) {
        case "-":
            iconName = "-";
            break;
        case "Delete":
            iconName = Delete;
            break;
        case "Archive":
            iconName = Archive;
            break;
        case "PinUnpin":
            iconName = Pin;
            break;
        case "ReadUnread":
            iconName = MailRead;
            break;
        case "FlagUnflag":
            iconName = Flag;
            break;
        case "Move":
            iconName = FolderArrowRight;
            break;
        default:
            iconName = "";
            break;
    }
    return {
        iconName,
        fallbackIconName: iconName,
        isImage: false,
    };
}

export function getHoverActionIconFromKey(action: string, iconName?: string, className?: string): SurfaceActionIconWithFluentIcon {
    let icon: SurfaceActionIconWithFluentIcon["icon"] = undefined;
    
    switch (action) {
        case "Delete":
            icon = <DeleteIcon className={className}/>;
            break;
        case "Archive":
            icon = <ArchiveIcon className={className}/>;
            break;
        case "PinUnpin":
            if (iconName === "PinRegular") {
                icon = <PinIcon className={className}/>;
            }
            else {
                icon = <PinFilled className={className}/>;
            }
            break;
        case "ReadUnread":
            if (iconName === "MailReadRegular") {
                icon = <MailReadIcon className={className}/>;
            }
            else {
                icon = <MailIcon className={className}/>;
            }
            break;
        case "FlagUnflag":
            if (iconName === "FlagFilled") {
                icon = <FlagFilled className={className}/>;
            }
            else if (iconName === "FlagRegular") {
                icon = <FlagIcon className={className}/>;
            }
            else {
                icon = <CheckmarkIcon className={className}/>;
            }
            break;
        case "Move":
            icon = <FolderArrowRightIcon className={className}/>;
            break;
        case "Settings":
            icon = <SettingsIcon className={className}/>;
            break;
        case "NotJunk":
            icon = <MailCheckmarkIcon className={className}/>;
            break;
        case "-":
        case "None":
        default:
            icon = undefined;
            break;
    }
    
    return {
        icon,
    };
}
